import { API_PREFIX } from '@/config/api'
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { auth } from '@rfc/rfc-components-library/helpers'
import type { PaginationDataType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'

const DEVICE_PREFIX = `${API_PREFIX}/devices`

const deviceApi = {
    getAvailableDevices: (filters: {
        start_at: Date
        end_at: Date
        page?: number
    }): Promise<PaginationDataType<PartnerModel[]>> =>
        auth.get(`${DEVICE_PREFIX}/free${buildQueryUrl({ filters }, true)}`).then(res => res.data)
}

export default deviceApi
